import { render, staticRenderFns } from "./saldiscountdiftrim.vue?vue&type=template&id=32e67a68&scoped=true&"
import script from "./saldiscountdiftrim.vue?vue&type=script&lang=js&"
export * from "./saldiscountdiftrim.vue?vue&type=script&lang=js&"
import style0 from "./saldiscountdiftrim.vue?vue&type=style&index=0&id=32e67a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e67a68",
  null
  
)

export default component.exports